import React from 'react';
import { Sparkles, CheckCircle2, Zap, BrainCircuit } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function SolutionSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="dark" title="Instant Intelligence" subtitle="EduAssess replaces the manual grind with an AI-powered pipeline that understands any content format." data-id="element-414">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-12" data-id="element-415">
        {/* Card 1 */}
        <div className="bg-slate-800/50 border border-slate-700 p-8 rounded-3xl hover:bg-slate-800 transition-colors group" data-id="element-416">
          <div className="w-14 h-14 rounded-2xl bg-indigo-500/20 text-indigo-400 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-417">
            <BrainCircuit className="w-8 h-8" data-id="element-418" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-419">Multi-Modal AI</h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-420">
            Our engine ingests Video, Audio, PDF, and PPT simultaneously. It
            doesn't just read text; it understands context, diagrams, and spoken
            lectures.
          </p>
        </div>

        {/* Card 2 */}
        <div className="bg-gradient-to-b from-indigo-900/50 to-slate-800/50 border border-indigo-500/30 p-8 rounded-3xl relative overflow-hidden group" data-id="element-421">
          <div className="absolute top-0 right-0 p-32 bg-indigo-500/10 blur-[60px] rounded-full pointer-events-none" data-id="element-422"></div>

          <div className="w-14 h-14 rounded-2xl bg-emerald-500/20 text-emerald-400 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-423">
            <Zap className="w-8 h-8" data-id="element-424" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-425">
            30 Seconds Flat
          </h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-426">
            Upload your source material and get a comprehensive, structured
            assessment with answer keys and metadata in half a minute.
          </p>
          <div className="mt-6 flex items-center gap-2 text-emerald-400 text-sm font-bold" data-id="element-427">
            <CheckCircle2 className="w-4 h-4" data-id="element-428" />
            <span data-id="element-429">99.9% Faster than manual</span>
          </div>
        </div>

        {/* Card 3 */}
        <div className="bg-slate-800/50 border border-slate-700 p-8 rounded-3xl hover:bg-slate-800 transition-colors group" data-id="element-430">
          <div className="w-14 h-14 rounded-2xl bg-amber-500/20 text-amber-400 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-431">
            <Sparkles className="w-8 h-8" data-id="element-432" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-433">Perfect Polish</h3>
          <p className="text-slate-400 leading-relaxed" data-id="element-434">
            Auto-formatted PDF exports with your institution's branding, logo,
            and instructions. Ready to print or distribute immediately.
          </p>
        </div>
      </div>
    </SlideLayout>;
}